var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueScroll',_vm._g(_vm._b({attrs:{"ops":_vm.ops}},'VueScroll',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }